export default __webpack_public_path__ + "static/media/background.0a70a8b1.png";